"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _SearchResult = _interopRequireDefault(require("./SearchResult"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ExternalLinkV = _interopRequireDefault(require("@insided/destination/icons/ExternalLinkV2"));

var ExternalSearchResult = function ExternalSearchResult(_ref) {
  var hit = _ref.hit,
      anchorRel = _ref.anchorRel,
      _clickCallback = _ref.clickCallback;
  var sourceKey = hit.source;
  return (0, _preact.h)(_SearchResult.default, {
    title: hit.title,
    url: hit.url || '',
    icon: (0, _preact.h)(_ExternalLinkV.default, {
      width: 20,
      height: 20
    }),
    content: hit.content,
    clickCallback: function clickCallback() {
      return _clickCallback();
    },
    anchorRel: anchorRel,
    target: "_blank",
    metaItems: [{
      type: 'text',
      text: (0, _preact.h)(_phrase.default, {
        m: "Forum",
        p: "federated.search.".concat(sourceKey)
      })
    }]
  });
};

var _default = ExternalSearchResult;
exports.default = _default;